


































import Vue from 'vue';
import { MStoreInputType, Autocomplete } from '@/types';
import { FormFieldValidation } from '@/mixins/formValidation';
import { ValidationModel } from '@/types/models/validation';

export default Vue.extend({
  name: 'MStoreFormTextarea',
  mixins: [FormFieldValidation],
  props: {
    autocomplete: {
      type: String,
      default: Autocomplete.off
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    },
    lazyFormatter: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    placeholder: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: MStoreInputType.Text,
      validator: (val) => {
        return [MStoreInputType.Email, MStoreInputType.Password, MStoreInputType.Search, MStoreInputType.Text, MStoreInputType.Url, MStoreInputType.Number].indexOf(val) !== -1;
      }
    },
    value: {
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    validation: {
      type: Object as () => ValidationModel
    },
    forceUpperCase: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    debounce: {
      type: Number,
      default: 0
    }
  },
  computed: {
    inputValue: {
      get(this: any) {
        return this.value;
      },
      set(this: any, value: string) {
        this.$emit('input', this.forceUpperCase ? value.toUpperCase() : value);
      }
    },
    isAutoComplete(this: any) {
      if (this.autocomplete === Autocomplete.on) {
        return this.autocomplete;
      } else if (this.type === MStoreInputType.Email) {
        return Autocomplete.nope;
      } else if (this.type === MStoreInputType.Password) {
        return Autocomplete.newPassword;
      } else {
        return Autocomplete.off;
      }
    }
  }
});
